<template>
  <drawer-bottom show="{{ show }}" title="{{title}}" bind:close="close" showDefaultNav class="main">
    <view class="container">
      <Tab
        wx:if="{{isTransfer}}"
        wx:style="marginBottom: 10px"
        tabKey="{{curTrainNo}}"
        tabList="{{tabList}}"
        bind:settabkey="setStayInfo"
      />
      <station-stay-info wx:if="{{ show }}" stayInfo="{{stayInfo}}" wx:style="height:100%;" />
    </view>
  </drawer-bottom>
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'

createComponent({
  props: {
    show: {
      type: Boolean,
      value: false
    },
    title: {
      type: String,
      value: '时刻表'
    },
    stayInfo: {
      type: Object,
      value: () => {}
    },
    isTransfer: {
      tyed: Boolean,
      value: false
    },
    currentTrain: {
      type: String,
      value: ''
    },
    stayInfoList: {
      type: Array,
      value: () => []
    }
  },
  data: {
    curTrainNo: ''
  },
  watch: {
    stayInfo: {
      immediate: true,
      deep: true,
      handler(item) {
        this.curTrainNo = item?.train_no ?? ''
      }
    }
  },
  computed: {
    tabList() {
      const list = []
      this.stayInfoList.forEach((item, index) => {
        const tab = {
          label: `第${index + 1}程${item.train_code}`,
          value: item.train_no
        }
        list.push(tab)
      })
      return list
    }
  },
  methods: {
    close() {
      this.triggerEvent('close')
    },
    setStayInfo({ detail }) {
      const key = detail
      const info = this.stayInfoList.find((item) => item.train_no === key)
      this.curTrainNo =  key
      this.triggerEvent('setStayInfo', info)
    }
  }
})
</script>

<style scoped lang="stylus">
.main
  /deep/ .header
    color #222
    line-height 1
    font-weight 400
    .drawer-title
      font-size 16px
      line-height 16px
      text-align center
  .container
    display flex
    flex-direction column
</style>

<script name="json">
module.exports = {
  component: true,
  usingComponents: {
    'drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
    'station-stay-info': '@/components/station-stay-info',
    Tab: '@/components/tab'
  }
}
</script>